import { render, staticRenderFns } from "./safety-inspection.vue?vue&type=template&id=672db24c&scoped=true&"
import script from "./safety-inspection.vue?vue&type=script&lang=js&"
export * from "./safety-inspection.vue?vue&type=script&lang=js&"
import style0 from "./safety-inspection.vue?vue&type=style&index=0&id=672db24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672db24c",
  null
  
)

export default component.exports